<div
  class="position-relative"
  tooltip="This response is restricted and cannot be viewed or modified."
  [tooltipEnabled]="matchingQuestionnaireResponse()?.isMasked || isItemRestricted()"
  [ngClass]="{ 'cursor-not-allowed': matchingQuestionnaireResponse()?.isMasked || isItemRestricted() }"
>
  <input
    type="text"
    class="form-input"
    [class.opacity-50]="isRefreshing()"
    [class.is-not-applicable]="notApplicable()"
    [class.form-input--invalid]="textAnswer.invalid && textAnswer.touched && hasAttemptedSubmit() && questionnaireItem()?.status === ClientRequestItemStatus.IN_REVIEW && isInReviewEditingEnabled()"
    [formControl]="textAnswer"
    [disabled]="isRefreshing() || textAnswer.disabled || matchingQuestionnaireResponse()?.isMasked || isItemRestricted()"
    (blur)="submitValue()"
    [attr.aria-describedby]="'request_item_questionnaire_' + sectionIndex() + '_' + documentIndex()"
    [dataSelector]="dataSelector + '-text-input-' + sectionIndex() + '-' + documentIndex()"
  />

  @if (isRefreshing()) {
    <div class="form-control__post-icon" [dataSelector]="dataSelector + '-loading-indicator'">
      <mat-spinner [diameter]="16" style="color: #B3B7C3"></mat-spinner>
    </div>
  }

  @if (textAnswer.invalid && textAnswer.touched && hasAttemptedSubmit() && questionnaireItem()?.status === ClientRequestItemStatus.IN_REVIEW && isInReviewEditingEnabled()) {
    <div class="error-message mt-1" [dataSelector]="dataSelector + '-error-message'">
      <span class="small-300 color-red-50">Response is required</span>
    </div>
  }
</div>
